// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"page_wrapper__g6b1r","main":"page_main__9jQXe"};